class Service {
    static token = null;
}

export default Service;